import { NavigationExtras, Router } from '@angular/router';

export interface LinkExtras<T = any> {
  title?: string;
  icon?: string;
  description?: string;
  data?: any;
  navigationExtras?: NavigationExtras;
}

export interface NavigationLink extends LinkExtras {
  commands: any[];
  navigate(extras?: NavigationExtras): Promise<boolean>;
  serializeUrl(extras?: NavigationExtras): string;
}

class NavigationLinkNode implements NavigationLink {
  public icon?: string;
  public title?: string;
  public description?: string;
  public data?: any;
  public navigationExtras?: NavigationExtras;
  constructor(protected readonly _router: Router, public commands: any[], extras: LinkExtras = {}) {
    this.icon = extras.icon;
    this.title = extras.title;
    this.description = extras.description;
    this.data = extras.data != null ? extras.data : {};
    this.navigationExtras = extras.navigationExtras;
  }

  public navigate(extras?: NavigationExtras) {
    extras = Object.assign({}, this.navigationExtras, extras);
    return this._router.navigate(this.commands, extras);
  }

  public serializeUrl(extras?: NavigationExtras) {
    extras = Object.assign({}, this.navigationExtras, extras);
    const tree = this._router.createUrlTree(this.commands, extras);
    return this._router.serializeUrl(tree);
  }

  public toJSON() {
    return {
      icon: this.icon,
      title: this.title,
      description: this.description,
      data: this.data,
      commands: this.commands,
      navigationExtras: this.navigationExtras,
    };
  }
}

export class NavigationServiceBase {
  constructor(protected readonly _router: Router) {}
  protected navigable(commands: any[], extras?: LinkExtras) {
    return new NavigationLinkNode(this._router, commands, extras);
  }
}
export class NavigableServiceBase extends NavigationLinkNode {
  constructor(commands: any[], protected readonly _router: Router, extras?: LinkExtras<any>) {
    super(_router, commands, extras);
  }

  public navigate(extras?: NavigationExtras) {
    return this._router.navigate(this.commands, extras);
  }

  public serializeUrl(extras?: NavigationExtras) {
    const tree = this._router.createUrlTree(this.commands, extras);
    return this._router.serializeUrl(tree);
  }

  protected navigable(commands: any[], extras?: LinkExtras) {
    return new NavigationLinkNode(this._router, [...this.commands, ...commands], extras);
  }
}
